import React from "react";
import { useNavigate } from "react-router-dom";
import { Clock, ArrowLeft } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export default function AdminPlaceholder({ title }) {
  const { t } = useI18n();
  const nav = useNavigate();
  return (
    <div className="fade-in w-full min-h-[60vh] flex items-center justify-center" data-testid="admin-placeholder">
      <div className="max-w-md text-center">
        <div className="w-16 h-16 rounded-2xl bg-white/[0.04] border border-white/10 flex items-center justify-center mx-auto mb-5">
          <Clock className="w-8 h-8 text-gray-400" />
        </div>
        <h1 className="text-2xl font-black tracking-tight mb-2" data-testid="admin-placeholder-title">{t(title)}</h1>
        <p className="text-sm text-gray-400 mb-7">{t("Diese Funktion folgt in Kürze. Die Seite ist bereits im Menü vorbereitet, damit die Struktur vollständig ist — echte Inhalte kommen im nächsten Schritt.")}</p>
        <button onClick={() => nav("/admin/today")} data-testid="admin-placeholder-back"
          className="bg-white/[0.06] hover:bg-white/10 text-white font-bold py-2.5 px-5 rounded-lg text-sm inline-flex items-center gap-2 transition-colors border border-white/10">
          <ArrowLeft className="w-4 h-4" /> {t("Zu «Heute wichtig»")}
        </button>
      </div>
    </div>
  );
}
